// Saved with the page layout so the editor and published page use the same spacing.
export const htmlPageChromeCss = `
.html-page-header-row,
.html-page-content-row,
.html-page-footer-row {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  position: relative;
}

.html-page-header-row,
.html-page-footer-row {
  min-height: 48px;
}

.html-page-content-row {
  min-height: 180px;
}

.html-page-footer-row .commoncontainerFooter .footerLinksSectionWrap.fix-wrapper,
.html-page-footer-row .commoncontainerFooter .tempdiv.fix-wrapper {
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
}

@media (max-width: 767px) {
  .html-page-footer-row .commoncontainerFooter .footerLinksSectionWrap.fix-wrapper,
  .html-page-footer-row .commoncontainerFooter .tempdiv.fix-wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }
}
`;
